import { contractRequest } from "@/portals/clinician/api/transport";
import type {
  CancelledInvitation,
  InvitationStatus,
  ItemsResponse,
  ClinicianInvitation,
  ClinicianListItem,
  ResentInvitation,
} from "@/portals/clinician/api/types";

// Same /api/v1/admin prefix as every other admin endpoint (see adminAuthApi.ts).
const BASE = "/api/v1/admin/clinicians";

// Invite and resend send the email before responding (SMTP plus the image
// attachment), so they can outlast the default 30s client timeout — the
// admin would see "took too long" for an invite that actually went out.
const EMAIL_SENDING_TIMEOUT_MS = 90_000;

/** 201 · 409 EMAIL_ALREADY_REGISTERED · 409 INVITE_ALREADY_PENDING · 400 VALIDATION_ERROR */
export const createClinicianInvitationApi = (email: string) =>
  contractRequest<ClinicianInvitation>(`${BASE}/invitations`, { method: "POST", body: { email }, portal: "admin", timeoutMs: EMAIL_SENDING_TIMEOUT_MS });

export const listClinicianInvitationsApi = (status?: InvitationStatus) =>
  contractRequest<ItemsResponse<ClinicianInvitation>>(
    `${BASE}/invitations${status ? `?status=${status}` : ""}`,
    { method: "GET", portal: "admin" },
  );

/** Issues a new link (old one dies) and resets expiry · 409 INVITE_NOT_RESENDABLE · 409 EMAIL_ALREADY_REGISTERED */
export const resendClinicianInvitationApi = (id: string) =>
  contractRequest<ResentInvitation>(`${BASE}/invitations/${encodeURIComponent(id)}/resend`, {
    method: "POST",
    portal: "admin",
    timeoutMs: EMAIL_SENDING_TIMEOUT_MS,
  });

/** 409 INVITE_NOT_CANCELLABLE */
export const cancelClinicianInvitationApi = (id: string) =>
  contractRequest<CancelledInvitation>(`${BASE}/invitations/${encodeURIComponent(id)}/cancel`, { method: "POST", portal: "admin" });

export const listCliniciansApi = () =>
  contractRequest<ItemsResponse<ClinicianListItem>>(BASE, { method: "GET", portal: "admin" });
